/* global axios */
// API da agenda da clínica (ver AGENDA.md).
import ApiClient from './ApiClient';

class AgendaAPI extends ApiClient {
  constructor() {
    super('agenda', { accountScoped: true });
  }

  getSetting() {
    return axios.get(`${this.url}/setting`);
  }

  updateSetting(data) {
    return axios.patch(`${this.url}/setting`, data);
  }

  getProfessionals() {
    return axios.get(`${this.url}/professionals`);
  }

  createProfessional(data) {
    return axios.post(`${this.url}/professionals`, data);
  }

  updateProfessional(id, data) {
    return axios.patch(`${this.url}/professionals/${id}`, data);
  }

  deleteProfessional(id) {
    return axios.delete(`${this.url}/professionals/${id}`);
  }

  getBlocks(params) {
    return axios.get(`${this.url}/blocks`, { params });
  }

  createBlock(data) {
    return axios.post(`${this.url}/blocks`, data);
  }

  deleteBlock(id) {
    return axios.delete(`${this.url}/blocks/${id}`);
  }

  getAppointments(params) {
    return axios.get(`${this.url}/appointments`, { params });
  }

  createAppointment(data) {
    return axios.post(`${this.url}/appointments`, data);
  }

  updateAppointment(id, data) {
    return axios.patch(`${this.url}/appointments/${id}`, data);
  }

  cancelAppointment(id, reason) {
    return axios.post(`${this.url}/appointments/${id}/cancel`, { reason });
  }

  getSlots(params) {
    return axios.get(`${this.url}/slots`, { params });
  }
}

export default new AgendaAPI();
